import { render, staticRenderFns } from "./WeeklyAvailability.vue?vue&type=template&id=168c0e1f&scoped=true&"
import script from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
export * from "./WeeklyAvailability.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyAvailability.vue?vue&type=style&index=0&id=168c0e1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c0e1f",
  null
  
)

export default component.exports